import React from 'react'
import { NavLink } from 'react-router-dom';
import logo from './image/Logo.png'

const Gst = () => {
  return (
    <div>


       <div className='container-fluid py-2   bg-white position-sticky top-0' style={{ boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.2)', zIndex:'999',marginTop:'-27px'}}>
        <div className='row' >
                <div className='col-10'>
                   <NavLink to="/home">  <img src={logo}  style={{width:'50px'}}/></NavLink>
                </div>
                <div className='col-2'>
                   <NavLink to="/"> <button className='btn text-primary ' style={{border:'1px solid gray'}}>Login</button></NavLink>
                </div>
            </div>
        </div>

        <div className='container mt-4'>
            <div className='row'>
                <div className='col-lg-12'>
                    <h3>GST Policy</h3>



                    <p  style={{fontSize:'14px'}}>From 1st October 2023, a new 28% Government Tax (GST) is applicable on the deposits.</p>
                    <p className='mt-3'  style={{fontSize:'14px'}}>Let's understand the new GST regime.. If a player deposits Rs.100 to play a game, there will be an inclusive 28% GST levied on the deposit amount, and the user will need to complete a transaction of Rs.100 (Rs. 78.13 + 28% of Rs. 78.13). Thus, Rs. 100 will be settled in the user’s deposit wallet, and Rs. 21.88 will be accounted for as GST paid. The exact GST amount will be credited to the user's bonus wallet. The details of GST paid by the user can be viewed in the View Transactions section on the application.</p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Gst